import { objectFromEntries } from 'src/utilidades';

export type ValuesObject = { readonly [value: string]: boolean };

export type Values<T extends ValuesObject> = T & FilterValuesFunctions<T>;

export function Values<T extends ValuesObject>(values: T): Values<T> {
    return new FilterValuesFunctions(values) as Values<T>;
}

class FilterValuesFunctions<T extends ValuesObject> {
    public constructor(values: T) {
        Object.assign(this, values);
    }

    public countChecked(this: this & T): number {
        return Object.values(this).filter(x => x).length;
    }

    public countUnchecked(this: this & T): number {
        return Object.values(this).filter(x => !x).length;
    }

    public withEveryAs(this: this & T, value: boolean): this & T {
        return this.with(objectFromEntries(Object.entries(this).map(([key]) => [key, value])) as T);
    }

    public withAllChecked(this: this & T): this & T {
        return this.withEveryAs(true);
    }

    public withAllUnchecked(this: this & T): this & T {
        return this.withEveryAs(false);
    }

    public withValueToggled(this: this & T, key: keyof T): this & T {
        return this.with({
            ...this,
            [key]: !this[key],
        });
    }

    public withAllUncheckedExcept(this: this & T, key: keyof T): this & T {
        return this.withAllUnchecked().withValue(key, true);
    }

    public withAllCheckedExcept(this: this & T, key: keyof T): this & T {
        return this.withAllUnchecked().withValue(key, false);
    }

    public withValue(this: this & T, key: keyof T, newValue: boolean): this & T {
        return new FilterValuesFunctions({ ...this, [key]: newValue }) as this & T;
    }

    private with(newValues: T): this & T {
        return new FilterValuesFunctions(newValues) as this & T;
    }
}



// WEBPACK FOOTER //
// ./src/componentes/CheckboxMenu/Values.tsx